import { GrowthPerformance } from "./applications/analytics/executive/GrowthPerformance/GrowthPerformance";
import { ComparativeSales } from "./applications/analytics/executive/ComparativeSales/ComparativeSales";
import { ComparativeSalesPerformance } from "./applications/analytics/executive/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { PerformanceByProductGroup } from "./applications/analytics/executive/PerformanceByProductGroup/PerformanceByProductGroup";
import { CustomerSales } from "./applications/analytics/executive/CustomerSales/CustomerSales";
import { CustomerGroupProduct } from "./applications/analytics/executive/CustomerGroupProduct/CustomerGroupProduct";

// Region dashboard when the user login is Executive
import { ExecutiveRegionComparativeSalesPerf } from "./applications/analytics/executiveregion/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { ExecutiveRegionPerformanceByProductGroup } from "./applications/analytics/executiveregion/PerformanceByProductGroup/PerformanceByProductGroup";
import { ExecutiveRegionComparativeSales } from "./applications/analytics/executiveregion/ComparativeSales/ComparativeSales";
import { ExecutiveRegionGrowthPerformance } from "./applications/analytics/executiveregion/GrowthPerformance/GrowthPerformance";
import { ExecutiveRegionCustomerSales } from "./applications/analytics/executiveregion/CustomerSales/CustomerSales";
import { ExecutiveRegionalCustomerGroupProduct } from "./applications/analytics/executiveregion/CustomerGroupProduct/CustomerGroupProduct";

import { DistrictComparativeSalesPerf } from "./applications/analytics/district/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { DistrictPerformanceByProductGroup } from "./applications/analytics/district/PerformanceByProductGroup/PerformanceByProductGroup";
import { DistrictComparativeSales } from "./applications/analytics/district/ComparativeSales/ComparativeSales";
import { DistrictGrowthPerformance } from "./applications/analytics/district/GrowthPerformance/GrowthPerformance";
import { DistrictCustomerSales } from "./applications/analytics/district/CustomerSales/CustomerSales";
import { DistrictCustomerGroupProduct } from "./applications/analytics/district/CustomerGroupProduct/CustomerGroupProduct";

import { AgentComparativeSalesPerf } from "./applications/analytics/agent/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { AgentPerformanceByProductGroup } from "./applications/analytics/agent/PerformanceByProductGroup/PerformanceByProductGroup";
import { AgentComparativeSales } from "./applications/analytics/agent/ComparativeSales/ComparativeSales";
import { AgentGrowthPerformance } from "./applications/analytics/agent/GrowthPerformance/GrowthPerformance";
import { AgentCustomerSales } from "./applications/analytics/agent/CustomerSales/CustomerSales";
import { AgentCustomerGroupProduct } from "./applications/analytics/agent/CustomerGroupProduct/CustomerGroupProduct";

import { RegionComparativeSalesPerf } from "./applications/analytics/region/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { RegionPerformanceByProductGroup } from "./applications/analytics/region/PerformanceByProductGroup/PerformanceByProductGroup";
import { RegionComparativeSales } from "./applications/analytics/region/ComparativeSales/ComparativeSales";
import { RegionGrowthPerformance } from "./applications/analytics/region/GrowthPerformance/GrowthPerformance";
import { RegionCustomerSales } from "./applications/analytics/region/CustomerSales/CustomerSales";
import { RegionalCustomerGroupProduct } from "./applications/analytics/region/CustomerGroupProduct/CustomerGroupProduct";

import { DistributorComparativeSalesPerf } from "./applications/analytics/distributor/ComparativeSalesPerformance";

import { CustomerComparativeSalesPerf } from "./applications/analytics/customer/ComparativeSalesPerformance";

import { ItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { DistrictItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance/DistrictComparativeSalesPerformance";
import { AgentItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance/AgentComparativeSalesPerformance";

import { ProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { DistrictProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance/DistrictComparativeSalesPerformance";
import { AgentProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance/AgentComparativeSalesPerformance";

import { OPMIColorScheme } from "../themes/theme-opmi";

import { ApplicationBrand, MenuItems, ApplicationItems } from "../client-configuration";

const exportApplication = {
  "applications": [
    {
      "id": 1,
      "name": "Comparative Sales Performance"
    },
    {
      "id": 3,
      "name": "Performance by Product Group"
    },
    {
      "id": 4,
      "name": "Comparative Sales"
    },
    {
      "id": 7,
      "name": "Customer Group Product"
    },
    {
      "id": 5,
      "name": "Growth Performance"
    },
    {
      "id": 6,
      "name": "Customer Sales"
    }
  ]
}

const exportApplicationCustomer = {
  "applications": [
    {
      "id": 1,
      "name": "Comparative Sales Performance"
    }
  ]
}

export const accountMapping = {
  Default: 0,
  Customer: 1,
  Doctor: 2,
  Agent: 3,
  Institution: 4
}

export const statusMapping = {
  pending: 0,
  success: 1,
  missed: 2,
  inprogress: 3,
  recovered: 4,
  advanced: 5,
  successjointcall: 8,
  recoveredjointcall: 9,
  advancedjointcall: 10
}

export const statusDisplayNames = {
  0: "Pending",
  1: "Success",
  2: "Missed",
  3: "In Progress",
  4: "Recovered",
  5: "Advanced",
  8: "Success Joint Call",
  9: "Recovered Joint Call",
  10: "Advanced Joint Call"
};

export const sessionType = {
  Pending: 0,
  Regular: 1,
  Advanced: 5,
  PastDue: 6,
  Recovery: 4,
  Incidental: 11
}

export const SessionTag = {
  advanced: 2,
  pastdue: 1,
  recovered: 3,
  incidental: 4
}

export const SyncStatusMap = {
  create: 1,
  update: 2,
  done: 3
}

export const LocationMap = {
  samples: 0,
  stockRoom: 1,
  shelf: 2
}

export const FileStatus = {
  pending: 0,
  notInLocal: 1,
  downloaded: 2
}

export const EvaluationTemplates = [
  {
    "ID": 1,
    "Description": "",
    "Version": 1,
    "TemplateJson": {
      general_evaluation: {
        show: true,
        max_chars: 255
      },
      factors: [
        {
          factor_id: "Xy7A9bTqW3",
          factor: "Pre-call Planning",
          description: "Assesses how well the representative prepared relevant data, objectives, and materials.",
          weight: 20,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "Pz5QmE2RnJ",
          factor: "Opening Call",
          description: "Evaluates the effectiveness of the introduction, rapport-building, and clarity of the call's purpose.",
          weight: 15,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "9LcD1WxYVu",
          factor: "Probe",
          description: "Measures the ability to ask meaningful questions that uncover the needs, interests, and prescribing behavior.",
          weight: 20,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "Ar0BnZk7Tp",
          factor: "Present/Deliver Key Message(s)",
          description: "Checks how clearly, confidently, and persuasively the representative delivered product messages.",
          weight: 20,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "t3NvGqWmXy",
          factor: "Closing Call",
          description: "Reviews how well the rep summarized key points, handled objections, and secured commitment or next steps.",
          weight: 15,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "g10vGqWmXy",
          factor: "Post-Call Analysis/Preview",
          description: "Evaluates the quality of the rep’s reflection, documentation, and planning for future interactions",
          weight: 15,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        }
      ]
    }
  },
  {
    "ID": 2,
    "Description": "",
    "Version": 1,
    "TemplateJson": {
      general_evaluation: {
        show: true,
        max_chars: 255
      },
      factors: [
        {
          factor_id: "Xy7A9bTqW3",
          factor: "Grooming",
          description: "Ensures professional and presentable appearance in the field.",
          weight: 15,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "Pz5QmE2RnJ",
          factor: "Rapport",
          description: "Builds trust and strong relationships",
          weight: 25,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "9LcD1WxYVu",
          factor: "Selling, Merchandising, Skills and Proficiency",
          description: "Applies effective selling techniques and displays products properly.",
          weight: 30,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "Ar0BnZk7Tp",
          factor: "Coverage Compliance",
          description: "Adheres to planned routes and visit schedules.",
          weight: 20,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "t3NvGqWmXy",
          factor: "Report Accuracy and System",
          description: "Submits timely and correct data using the system.",
          weight: 10,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        }
      ]
    }
  },
  {
    "ID": 3,
    "Description": "",
    "Version": 1,
    "TemplateJson": {
      general_evaluation: {
        show: true,
        max_chars: 255
      },
      factors: [
        {
          factor_id: "Xy7A9bTqW3",
          factor: "Grooming",
          description: "Ensures professional and presentable appearance in the field.",
          weight: 15,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "Pz5QmE2RnJ",
          factor: "Rapport",
          description: "Builds trust and strong relationships",
          weight: 25,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "9LcD1WxYVu",
          factor: "Selling, Merchandising, Skills and Proficiency",
          description: "Applies effective selling techniques and displays products properly.",
          weight: 30,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "Ar0BnZk7Tp",
          factor: "Coverage Compliance",
          description: "Adheres to planned routes and visit schedules.",
          weight: 20,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        },
        {
          factor_id: "t3NvGqWmXy",
          factor: "Report Accuracy and System",
          description: "Submits timely and correct data using the system.",
          weight: 10,
          grading: [
            { value: 1, note: "Needs Improvement" },
            { value: 2, note: "Unsatisfactory" },
            { value: 3, note: "Satisfactory" },
            { value: 4, note: "Very Good" },
            { value: 5, note: "Outstanding", highest: true }
          ],
          text_evaluations: [
            { label: "Strong Points", max_chars: 255 },
            { label: "Weak Points", max_chars: 255 },
            { label: "Recommendation", max_chars: 255 }
          ]
        }
      ]
    }
  }
]

export const Announcements = [
  {
    "ID": 1,
    "Date": "2025-06-01T00:00:00",
    "Message": "Dr. Santos will be covering for Dr. Reyes in General Surgery.",
    "Priority": 2
  },
  {
    "ID": 2,
    "Date": "2025-06-01T00:00:00",
    "Message": "Staff meeting scheduled at 2:00 PM in Conference Room B.",
    "Priority": 1
  },
  {
    "ID": 3,
    "Date": "2025-06-02T00:00:00",
    "Message": "Happy birthday to Dr. Lim!",
    "Priority": 1
  },
  {
    "ID": 4,
    "Date": "2025-06-02T00:00:00",
    "Message": "Dr. Chen is on-call for the Emergency Department.",
    "Priority": 1
  },
  {
    "ID": 5,
    "Date": "2025-06-03T00:00:00",
    "Message": "Nursing staff training at 10:00 AM in Hall A.",
    "Priority": 1
  },
  {
    "ID": 6,
    "Date": "2025-06-03T00:00:00",
    "Message": "Warm wishes to Nurse Angela on her birthday!",
    "Priority": 1
  },
  {
    "ID": 7,
    "Date": "2025-06-04T00:00:00",
    "Message": "Dr. Mendoza is handling all Cardiology rounds.",
    "Priority": 1
  },
  {
    "ID": 8,
    "Date": "2025-06-04T00:00:00",
    "Message": "Quality Assurance review session at 4:00 PM.",
    "Priority": 1
  },
  {
    "ID": 9,
    "Date": "2025-06-05T00:00:00",
    "Message": "Join us in celebrating Dr. Villanueva’s birthday today.",
    "Priority": 1
  },
  {
    "ID": 10,
    "Date": "2025-06-05T00:00:00",
    "Message": "Dr. Ramos will assist in Outpatient Consultations.",
    "Priority": 1
  }
]

export const Agent = [
  {
    "ID": 1,
    "Code": "NS1",
    "Name": "MARCELINO NARCIDA III"
  },
  {
    "ID": 2,
    "Code": "NS2",
    "Name": "NAPOLEON DE CASTRO JR"
  },
  {
    "ID": 3,
    "Code": "RS2",
    "Name": "MANUEL TEJADA"
  },
  {
    "ID": 4,
    "Code": "RS1",
    "Name": "DONELL DANGILAN"
  },
  {
    "ID": 5,
    "Code": "RS3",
    "Name": "GERALD ALTAVANO"
  },
  {
    "ID": 6,
    "Code": "RS4",
    "Name": "NATHANIEL IWAY"
  },
  {
    "ID": 7,
    "Code": "VS2",
    "Name": "JOY BANDOJO"
  },
  {
    "ID": 8,
    "Code": "VS1",
    "Name": "JOSEPH MISSION"
  },
  {
    "ID": 9,
    "Code": "MN1",
    "Name": "JOHN PAUL JUYAD"
  },
  {
    "ID": 10,
    "Code": "TER-GMA1-L08",
    "Name": "VACANT "
  },
  {
    "ID": 11,
    "Code": "TER-GMA1-N01",
    "Name": "VACANT "
  },
  {
    "ID": 12,
    "Code": "TER-GMA1-W01",
    "Name": "VACANT "
  },
  {
    "ID": 13,
    "Code": "TER-GMA2-E02",
    "Name": "VACANT "
  },
  {
    "ID": 14,
    "Code": "TER-GMA2-S02",
    "Name": "VACANT "
  },
  {
    "ID": 15,
    "Code": "TER-GMA2-C02",
    "Name": "VACANT "
  },
  {
    "ID": 16,
    "Code": "TER-LUZ-SLAG",
    "Name": "VACANT "
  },
  {
    "ID": 17,
    "Code": "TER-LUZ-SBAT",
    "Name": "VACANT "
  },
  {
    "ID": 18,
    "Code": "TER-LUZ-SQC",
    "Name": "VACANT "
  },
  {
    "ID": 19,
    "Code": "TER-LUZ-NBAG",
    "Name": "VACANT "
  },
  {
    "ID": 20,
    "Code": "TER-LUZ-NPAM",
    "Name": "VACANT "
  },
  {
    "ID": 21,
    "Code": "TER-LUZ-NTAR",
    "Name": "VACANT "
  },
  {
    "ID": 22,
    "Code": "TER-VIS-CEBN",
    "Name": "VACANT "
  },
  {
    "ID": 23,
    "Code": "TER-VIS-CEBS",
    "Name": "VACANT "
  },
  {
    "ID": 24,
    "Code": "TER-VIS-BAC",
    "Name": "VACANT "
  },
  {
    "ID": 25,
    "Code": "TER-MIN-CAG",
    "Name": "VACANT "
  },
  {
    "ID": 26,
    "Code": "TER-MIN-DAV",
    "Name": "VACANT "
  },
  {
    "ID": 27,
    "Code": "FS-NGM-100",
    "Name": "VACANT "
  },
  {
    "ID": 28,
    "Code": "FS-SGM-100",
    "Name": "VACANT "
  },
  {
    "ID": 29,
    "Code": "FS-SGM-200",
    "Name": "VACANT "
  },
  {
    "ID": 30,
    "Code": "FS-SL-100",
    "Name": "VACANT "
  },
  {
    "ID": 31,
    "Code": "FS-NL-100",
    "Name": "VACANT "
  },
  {
    "ID": 32,
    "Code": "FS-NL-200",
    "Name": "VACANT "
  },
  {
    "ID": 33,
    "Code": "FS-CEV-100",
    "Name": "VACANT "
  },
  {
    "ID": 34,
    "Code": "FS-VIS-100",
    "Name": "VACANT "
  },
  {
    "ID": 35,
    "Code": "FS-NOM-100",
    "Name": "VACANT "
  },
  {
    "ID": 36,
    "Code": "FS-SOM-100",
    "Name": "VACANT "
  },
  {
    "ID": 37,
    "Code": "DIR1",
    "Name": "DIRECT CUST"
  },
  {
    "ID": 38,
    "Code": "D1-102",
    "Name": "JUANITO KO, JR."
  },
  {
    "ID": 39,
    "Code": "D1-101",
    "Name": "VINCENT VELASCO"
  },
  {
    "ID": 40,
    "Code": "D1-103",
    "Name": "DONILL JESTER SANTIAGO"
  },
  {
    "ID": 41,
    "Code": "D1-104",
    "Name": "FLOYD BUNAG"
  },
  {
    "ID": 42,
    "Code": "D1-105",
    "Name": "SHAIRA MAE BONTOL"
  },
  {
    "ID": 43,
    "Code": "D1-105",
    "Name": "GMAS-VACANT"
  },
  {
    "ID": 44,
    "Code": "D2-205",
    "Name": "GMAW-VACANT"
  },
  {
    "ID": 45,
    "Code": "D2-203",
    "Name": "JONELL LINDO"
  },
  {
    "ID": 46,
    "Code": "D2-202",
    "Name": "JENNIFER TRONO"
  },
  {
    "ID": 47,
    "Code": "D2-201",
    "Name": "BRIAN LU"
  },
  {
    "ID": 48,
    "Code": "D1-100",
    "Name": "JOPREY PIANO"
  },
  {
    "ID": 49,
    "Code": "D2-200",
    "Name": "JAYVEE COLLADO"
  }
]

export const Client = [
  {
    "ID": 275963,
    "Name": "MDC Davao del Sur TAGUM CITY GAISANO MALL"
  },
  {
    "ID": 275965,
    "Name": "MDC South Cotabato SURALLAH ALLAH VALLEY DRIVE"
  },
  {
    "ID": 275966,
    "Name": "MDC SOUTHERN LEYTE SOGOD POBLACION"
  },
  {
    "ID": 275967,
    "Name": "MDC Davao del Sur del Sur Davao del Sur del Sur CITY QUIMPO ECOWEST"
  },
  {
    "ID": 275969,
    "Name": "MDC LEYTE TACLOBAN CITY SAGKAHAN"
  },
  {
    "ID": 275970,
    "Name": "MDC NEGROS ORIENTAL DUMAGUETE CITY CALINDAGAN"
  },
  {
    "ID": 275971,
    "Name": "MDC AGUSAN DEL NORTE CABADBARAN CITY NATIONAL HIGHWAY"
  },
  {
    "ID": 275973,
    "Name": "MDC Negros Occicental BACOLOD CITY B S AQUINO DRIVE 21ST"
  },
  {
    "ID": 275974,
    "Name": "MDC ILOILO CITY MANDURRIAO"
  },
  {
    "ID": 275975,
    "Name": "MDC North Cotabato KIDAPAWAN CITY Quezon City"
  }
]

export const File = [
  {
    "ID": 1,
    "FileType": 1,
    "FileName": "NJPPK Detailer_1-9",
    "Extension": ".pdf",
    "SearchTags": "invoice,april,finance",
    "Status": 1,
    "StoragePath": "/files/2023/NJPPK Detailer_1-9.pdf",
    "AccessUrl": "/files/NJPPK Detailer_1-9.pdf",
    "SizeClassification": "large",
    "UploadBy": 1,
    "UploadedDate": "2023-04-11T09:00:00",
    "ApprovedBy": 1,
    "ApprovedDate": "2023-04-11T10:30:00",
    "UserType": 3
  },
  {
    "ID": 2,
    "FileType": 1,
    "FileName": "NJ PPJ Sore T - p1",
    "Extension": ".png",
    "SearchTags": "meeting,minutes,march",
    "Status": 1,
    "StoragePath": "/files/2023/NJ PPJ Sore T - p1.png",
    "AccessUrl": "/files/NJ PPJ Sore T - p1.png",
    "SizeClassification": "small",
    "UploadBy": 2,
    "UploadedDate": "2023-03-28T14:15:00",
    "ApprovedBy": 3,
    "ApprovedDate": "2023-03-30T11:00:00",
    "UserType": 3
  },
  {
    "ID": 3,
    "FileType": 3,
    "FileName": "NJ PPK Cough - p1",
    "Extension": ".png",
    "SearchTags": "product,image,sample",
    "Status": 1,
    "StoragePath": "/images/products/sample.jpg",
    "AccessUrl": "/files/NJ PPK Cough - p1.png",
    "SizeClassification": "small",
    "UploadBy": 6,
    "UploadedDate": "2023-04-05T13:45:00",
    "ApprovedBy": 1,
    "ApprovedDate": "2023-04-06T09:15:00",
    "UserType": 3
  },
  {
    "ID": 4,
    "FileType": 4,
    "FileName": "NJ PPK Cough Preps Table",
    "Extension": ".jpg",
    "SearchTags": "logo,company,branding",
    "Status": 1,
    "StoragePath": "/branding/logo.png",
    "AccessUrl": "/files/NJ PPK Cough Preps Table.jpg",
    "SizeClassification": "small",
    "UploadBy": 7,
    "UploadedDate": "2023-04-10T16:30:00",
    "ApprovedBy": 8,
    "ApprovedDate": "2023-04-11T10:00:00",
    "UserType": 3
  }
]

const nullData = {
  "sections": [],
  "palettes": [],
  "themes": []
}

export const ExecutiveData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": ComparativeSalesPerformance,
  "3": PerformanceByProductGroup,
  "4": ComparativeSales,
  "5": GrowthPerformance,
  "6": CustomerSales,
  "7": CustomerGroupProduct,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const DistrictData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": DistrictComparativeSalesPerf,
  "3": DistrictPerformanceByProductGroup,
  "4": DistrictComparativeSales,
  "5": DistrictGrowthPerformance,
  "6": DistrictCustomerSales,
  "7": DistrictCustomerGroupProduct,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const AgentData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": AgentComparativeSalesPerf,
  "3": AgentPerformanceByProductGroup,
  "4": AgentComparativeSales,
  "5": AgentGrowthPerformance,
  "6": AgentCustomerSales,
  "7": AgentCustomerGroupProduct,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const ExecutiveRegionalData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": ExecutiveRegionComparativeSalesPerf,
  "3": ExecutiveRegionPerformanceByProductGroup,
  "4": ExecutiveRegionComparativeSales,
  "5": ExecutiveRegionGrowthPerformance,
  "6": ExecutiveRegionCustomerSales,
  "7": ExecutiveRegionalCustomerGroupProduct,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const RegionalData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": RegionComparativeSalesPerf,
  "3": RegionPerformanceByProductGroup,
  "4": RegionComparativeSales,
  "5": RegionGrowthPerformance,
  "6": RegionCustomerSales,
  "7": RegionalCustomerGroupProduct,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const DistributorData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": DistributorComparativeSalesPerf,
  "3": nullData,
  "4": nullData,
  "5": nullData,
  "6": nullData,
  "7": nullData,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const CustomerData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": CustomerComparativeSalesPerf,
  "3": nullData,
  "4": nullData,
  "5": nullData,
  "6": nullData,
  "7": nullData,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const AgentProductData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": AgentItemsComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const DistrictProductData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": DistrictItemsComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const ProductData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": ItemsComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const ProductGroupData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": ProductGroupComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const AgentProductGroupData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": AgentProductGroupComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const DistrictProductGroupData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": DistrictProductGroupComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const DefaultData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  'applicationdashboard': exportApplication,
  'colorScheme': OPMIColorScheme,
  'menuItems': MenuItems,
  "sections": [],
  "palettes": [],
  "themes": []
};
